// Module
var code = "<cSpinner/> ";
// Exports
export default code;